import {ModuleCode} from './moduleRegistry'

export type ModulePresentation = {
  shortName: string
  description: string
  icon: string
  accent: string
  focusAreas: readonly string[]
}

export const MODULE_PRESENTATION: Readonly<Record<ModuleCode, ModulePresentation>> = {
  quality: {
    shortName: 'Kalite',
    description: 'PDCA döngüleri, kanıtlar, raporlar ve kurumsal iyileştirme süreçleri.',
    icon: '/media/icons/duotune/general/gen026.svg',
    accent: '#6d5dfc',
    focusAreas: ['PDCA', 'Kanıt yönetimi', 'Olgunluk', 'Raporlama'],
  },
  curriculum: {
    shortName: 'Müfredat',
    description: 'Ders, program ve öğrenme çıktılarının uçtan uca yönetimi.',
    icon: '/media/icons/duotune/abstract/abs027.svg',
    accent: '#0e9f8a',
    focusAreas: ['Program çıktıları', 'Ders çıktıları', 'Matrisler', 'Kurul modülleri'],
  },
  'survey-feedback': {
    shortName: 'Anket',
    description: 'Anket uygulamaları, geri bildirimler ve sonuç eğilimleri.',
    icon: '/media/icons/duotune/communication/com014.svg',
    accent: '#0d8bd9',
    focusAreas: ['Bekleyen anketler', 'Geri bildirim', 'Sonuçlar', 'Eğilimler'],
  },
  assessment: {
    shortName: 'Ölçme',
    description: 'Sınav, soru bankası ve ölçme-değerlendirme operasyonları.',
    icon: '/media/icons/duotune/general/gen019.svg',
    accent: '#805ad5',
    focusAreas: ['Dersler', 'Sınav tasarımı', 'Soru havuzu', 'Optik ve sonuçlar'],
  },
  'course-exam-schedule': {
    shortName: 'Program',
    description: 'Ders ve sınav programları, görevler, mekânlar ve değişim süreçleri.',
    icon: '/media/icons/duotune/general/gen014.svg',
    accent: '#087ea4',
    focusAreas: ['Ders programı', 'Sınav programı', 'Görevler', 'Mekânlar'],
  },
  'academic-advising': {
    shortName: 'Danışmanlık',
    description: 'Danışmanlık öğrencileri, görüşme kayıtları ve akademik takip süreçleri.',
    icon: '/media/icons/duotune/communication/com006.svg',
    accent: '#0f766e',
    focusAreas: ['Danışmanlık öğrencileri', 'Görüşmeler', 'Akademik takip', 'Destek ihtiyaçları'],
  },
  bap: {
    shortName: 'BAP',
    description: 'Bilimsel araştırma projesi başvuru ve yönetim süreçleri.',
    icon: '/media/icons/duotune/finance/fin006.svg',
    accent: '#be7c00',
    focusAreas: ['Başvurular', 'Değerlendirme', 'Projeler', 'Raporlar'],
  },
  committee: {
    shortName: 'Kurullar',
    description: 'Kurul ve komisyon toplantılarının karar yaşam döngüsü.',
    icon: '/media/icons/duotune/communication/com013.svg',
    accent: '#b83280',
    focusAreas: ['Toplantılar', 'Gündem', 'Kararlar', 'Tutanaklar'],
  },
  'student-clearance': {
    shortName: 'İlişik',
    description: 'İlişik kesme başvuruları, onay adımları ve süreç görünürlüğü.',
    icon: '/media/icons/duotune/files/fil008.svg',
    accent: '#d97706',
    focusAreas: ['Başvurular', 'Onaylar', 'Bekleyen işler', 'Tamamlananlar'],
  },
  'graduate-card': {
    shortName: 'Mezun',
    description: 'Mezun kartı, başvuru ve doğrulama deneyimi.',
    icon: '/media/icons/duotune/electronics/elc005.svg',
    accent: '#059669',
    focusAreas: ['Kart durumu', 'Başvurular', 'Doğrulama', 'Mezun hizmetleri'],
  },
  'academic-workload': {
    shortName: 'İş Yükü',
    description: 'Ek ders ve akademik iş yükü bildirim, hesaplama ve onayları.',
    icon: '/media/icons/duotune/graphs/gra008.svg',
    accent: '#2563eb',
    focusAreas: ['Bildirimler', 'Hesaplamalar', 'Onaylar', 'Ziyaretler'],
  },
  analytics: {
    shortName: 'Analitik',
    description: 'Yönetici metrikleri, kurumsal eğilimler ve dinamik raporlar.',
    icon: '/media/icons/duotune/graphs/gra001.svg',
    accent: '#dc4c64',
    focusAreas: ['KPI', 'Eğilimler', 'Karşılaştırmalar', 'Dinamik raporlar'],
  },
  admin: {
    shortName: 'Yönetim',
    description: 'Kullanıcı, rol, yetki, menü ve sistem yapılandırması.',
    icon: '/media/icons/duotune/coding/cod001.svg',
    accent: '#4b5563',
    focusAreas: ['Kullanıcılar', 'Roller', 'Yetkiler', 'Sistem ayarları'],
  },
}
